import { useRouteMatch } from "react-router-dom";
import TicketsEdit from "./TicketsEdit";
import RouteIdParams from "../../System/RouteIdParams";

interface TicketsEditRootProps {
    
}

export default function TicketsEditRoot(props: TicketsEditRootProps) {
    const match = useRouteMatch<RouteIdParams>();
    return (
        <TicketsEdit key={match.params.id} />
    )
}